import { render, staticRenderFns } from "./ProfileUploadDocument.vue?vue&type=template&id=247a0a6c&scoped=true&"
import script from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"
export * from "./ProfileUploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a0a6c",
  null
  
)

export default component.exports